export type AlertCriticalityColor = "success" | "warning" | "danger";

const WARNING_MAX_OCCURRENCES = 5;

export const resolveAlertCriticality = (occurrences: number): AlertCriticalityColor => {
  if (occurrences <= 0) return "success";
  if (occurrences <= WARNING_MAX_OCCURRENCES) return "warning";
  return "danger";
};
